import { normalizeText } from './maps.js'
import { formatLocalizedBombCount, t } from './i18n.js'

const OG_WIDTH = 1200
const OG_HEIGHT = 630
const BUILD_PREVIEW_SIZE = 640
const BRAND = 'Build & Destroy'

export async function createBuildOpenGraphImage({ scene }) {
    const canvas = scene.captureFrame({ width: OG_WIDTH, height: OG_HEIGHT, snapCamera: true })

    return canvasToBlob(canvas)
}

export async function createBuildPreviewImage({ scene }) {
    const canvas = scene.captureBuildPreview({ width: BUILD_PREVIEW_SIZE, height: BUILD_PREVIEW_SIZE })
    return canvasToBlob(canvas, 'image/webp', 0.84)
}

export async function createResultOpenGraphImage({ scene, build, destroyerName, bombsUsed }) {
    const canvas = scene.captureFrame({ width: OG_WIDTH, height: OG_HEIGHT })
    const context = canvas.getContext('2d')
    const playerName = normalizeText(destroyerName, t('defaults.destroyer'), 40)
    const title = normalizeText(build?.title, t('defaults.untitledFortress'), 64)

    drawResultBackdrop(context)
    drawBrand(context)

    context.fillStyle = '#ffffff'
    context.font = '900 82px Inter, ui-sans-serif, system-ui, sans-serif'
    context.textBaseline = 'top'
    drawWrappedText(context, t('openGraph.destroyedIt', { playerName }), 84, 142, 760, 92, 2)

    context.font = '850 44px Inter, ui-sans-serif, system-ui, sans-serif'
    context.fillStyle = '#fff2b3'
    context.fillText(formatBombCount(bombsUsed), 88, 342)

    context.font = '800 34px Inter, ui-sans-serif, system-ui, sans-serif'
    context.fillStyle = 'rgba(255, 255, 255, 0.86)'
    drawWrappedText(context, title, 88, 412, 680, 42, 2)

    return canvasToBlob(canvas)
}

function drawResultBackdrop(context) {
    const gradient = context.createLinearGradient(0, 0, OG_WIDTH, 0)
    gradient.addColorStop(0, 'rgba(7, 13, 18, 0.9)')
    gradient.addColorStop(0.52, 'rgba(12, 20, 28, 0.66)')
    gradient.addColorStop(1, 'rgba(12, 20, 28, 0.18)')
    context.fillStyle = gradient
    context.fillRect(0, 0, OG_WIDTH, OG_HEIGHT)

    context.fillStyle = 'rgba(255, 64, 95, 0.82)'
    context.fillRect(0, 0, 14, OG_HEIGHT)
}

function drawBrand(context) {
    context.fillStyle = 'rgba(255, 255, 255, 0.72)'
    context.font = '850 24px Inter, ui-sans-serif, system-ui, sans-serif'
    context.textBaseline = 'top'
    context.fillText(BRAND, 88, 78)
}

function drawWrappedText(context, text, x, y, maxWidth, lineHeight, maxLines) {
    const words = String(text).split(/\s+/).filter(Boolean)
    const lines = []
    let line = ''

    for (const word of words) {
        const nextLine = line ? `${line} ${word}` : word
        if (context.measureText(nextLine).width <= maxWidth) {
            line = nextLine
            continue
        }

        if (line) {
            lines.push(line)
        }
        line = word

        if (lines.length === maxLines) {
            break
        }
    }

    if (line && lines.length < maxLines) {
        lines.push(line)
    }

    lines.slice(0, maxLines).forEach((lineText, index) => {
        context.fillText(lineText, x, y + index * lineHeight)
    })
}

function formatBombCount(value) {
    return formatLocalizedBombCount(value, { needed: true })
}

function canvasToBlob(canvas, type = 'image/png', quality = undefined) {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(blob)
                return
            }

            reject(new Error('OpenGraph image could not be encoded.'))
        }, type, quality)
    })
}
